<template>
  <!--
      作者 kmdshop
      时间：2020-06-09
      描述：会员-短信明细
  -->
  <div class="user">
    <!-- 短信统计卡片 -->
    <div class="sms-statistics-card">
      <el-card shadow="never" class="statistics-card">
        <div class="statistics-content">
          <div class="statistics-item">
            <div class="statistics-label">当前短信剩余总量</div>
            <div class="statistics-value">
              <span class="sms-count">{{ totalSmsCount }}</span>
              <span class="sms-unit">条</span>
            </div>
          </div>
          <div class="statistics-operations">
            <el-button 
              type="primary" 
              size="small" 
              icon="el-icon-edit" 
              @click="showAdjustDialog"
            >
              调整数量
            </el-button>
            
          </div>
        </div>
      </el-card>
      
      <!-- 调整短信数量对话框 -->
      <el-dialog
        title="调整短信数量"
        :visible.sync="adjustDialogVisible"
        width="500px"
        :close-on-click-modal="false"
      >
        <el-form :model="adjustForm" label-width="120px" ref="adjustForm" :rules="adjustRules">
          <el-form-item label="调整类型" prop="adjustType">
            <el-radio-group v-model="adjustForm.adjustType">
              <el-radio label="increase">增加</el-radio>
              <el-radio label="decrease">减少</el-radio>
              <el-radio label="set">直接设置</el-radio>
            </el-radio-group>
          </el-form-item>
          
          <el-form-item label="调整数量" prop="adjustAmount" v-if="adjustForm.adjustType !== 'set'">
            <el-input-number
              v-model="adjustForm.adjustAmount"
              :min="1"
              :max="adjustForm.adjustType === 'increase' ? 1000000 : totalSmsCount"
              :step="100"
              controls-position="right"
              style="width: 200px"
            >
              <template slot="append">条</template>
            </el-input-number>
          </el-form-item>
          
          <el-form-item label="设置数量" prop="setAmount" v-if="adjustForm.adjustType === 'set'">
            <el-input-number
              v-model="adjustForm.setAmount"
              :min="0"
              :max="1000000"
              :step="100"
              controls-position="right"
              style="width: 200px"
            >
              <template slot="append">条</template>
            </el-input-number>
          </el-form-item>
          
          <el-form-item label="调整后数量" prop="finalAmount">
            <el-input 
              v-model="adjustForm.finalAmount" 
              disabled
              style="width: 200px"
            >
              <template slot="append">条</template>
            </el-input>
          </el-form-item>
          
          <!-- <el-form-item label="调整原因" prop="reason">
            <el-input
              type="textarea"
              v-model="adjustForm.reason"
              placeholder="请输入调整原因（必填）"
              maxlength="200"
              show-word-limit
              rows="3"
            ></el-input>
          </el-form-item>
          
          <el-form-item label="操作备注" prop="remark">
            <el-input
              type="textarea"
              v-model="adjustForm.remark"
              placeholder="可选：记录更多详细信息"
              maxlength="200"
              show-word-limit
              rows="2"
            ></el-input>
          </el-form-item> -->
        </el-form>
        
        <span slot="footer" class="dialog-footer">
          <el-button @click="adjustDialogVisible = false">取消</el-button>
          <el-button 
            type="primary" 
            @click="submitAdjust" 
            :loading="adjustLoading"
          >
            确认调整
          </el-button>
        </span>
      </el-dialog>
    </div>

    <!--搜索表单-->
    <div class="common-seach-wrap">
      <el-form size="small" :inline="true" :model="formInline" class="demo-form-inline">
        <el-form-item label="用户昵称">
          <el-input v-model="formInline.search" placeholder="请输入昵称"></el-input>
        </el-form-item>
        <el-form-item label="短信变动场景">
          <el-select v-model="formInline.scene" placeholder="请选择">
            <el-option label="全部" value="0"></el-option>
            <el-option v-for="(item,index) in Scene" :key="index" :label="item.name" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="起始日期">
          <div class="block">
            <span class="demonstration"></span>
            <el-date-picker v-model="formInline.value1" type="daterange"  value-format="yyyy-MM-dd" range-separator="至" start-placeholder="开始日期"
              end-placeholder="结束日期">
            </el-date-picker>
          </div>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="onSubmit">查询</el-button>
        </el-form-item>
      </el-form>
    </div>
    
    <!--内容-->
    <div class="product-content">
      <div class="table-wrap">
        <el-table size="small" :data="tableData" border style="width: 100%" v-loading="loading">
          <el-table-column prop="user_id" label="ID" width="80"></el-table-column>
          <el-table-column prop="user.nickName" label="微信头像" width="70">
            <template slot-scope="scope">
              <img :src="scope.row.user.avatarUrl" width="30" height="30" />
            </template>
          </el-table-column>
          <el-table-column prop="user.nickName" label="昵称">
            <template slot-scope="scope">
              <span>{{scope.row.user.nickName}}</span>
              <span class="gray9">(用户ID：{{scope.row.user.user_id}})</span>
            </template>
          </el-table-column>
          <el-table-column prop="scene.text" label="短信变动场景">
            <template slot-scope="scope">
              <span v-if="scope.row.scene.value==10" style="color: #409EFF">{{scope.row.scene.text}}</span>
              <span v-if="scope.row.scene.value==20" style="color: #67C23A">{{scope.row.scene.text}}</span>
              <span v-if="scope.row.scene.value==30" style="color: #F56C6C">{{scope.row.scene.text}}</span>
              <span v-if="scope.row.scene.value==40" style="color: #E6A23C">{{scope.row.scene.text}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="money" label="变动金额">
            <template slot-scope="scope">
              <p v-if="scope.row.money > 0">+{{scope.row.money}}</p>
              <p v-else>{{scope.row.money}}</p>
            </template>
          </el-table-column>
          <el-table-column prop="current_money" label="最终金额"></el-table-column>
          <el-table-column prop="describe" label="描述/说明" width="200"></el-table-column>
          <el-table-column prop="remark" label="管理员备注">
            <template slot-scope="scope">
              <p v-if="scope.row.remark ==''">--</p>
              <p v-else>{{scope.row.remark}}</p>
            </template>
          </el-table-column>
          <el-table-column prop="create_time" label="创建时间" width="140"></el-table-column>
        </el-table>
      </div>

      <!--分页-->
      <div class="pagination">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" background :current-page="curPage"
          :page-size="pageSize" layout="total, prev, pager, next, jumper"
          :total="totalDataNumber">
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
  import UserApi from '@/api/user.js';
  export default {
    data() {
      // 调整数量验证规则
      const validateAdjustAmount = (rule, value, callback) => {
        if (this.adjustForm.adjustType !== 'set' && (!value || value <= 0)) {
          callback(new Error('请输入调整数量'));
        } else {
          callback();
        }
      };
      
      const validateSetAmount = (rule, value, callback) => {
        if (this.adjustForm.adjustType === 'set' && (value === null || value === undefined)) {
          callback(new Error('请输入设置数量'));
        } else {
          callback();
        }
      };
      
      // const validateReason = (rule, value, callback) => {
      //   if (!value || value.trim() === '') {
      //     callback(new Error('请输入调整原因'));
      //   } else {
      //     callback();
      //   }
      // };

      return {
        /*是否加载完成*/
        loading: true,
        /*列表数据*/
        tableData: [],
        /*一页多少条*/
        pageSize: 20,
        /*一共多少条数据*/
        totalDataNumber: 0,
        /*当前是第几页*/
        curPage: 1,
        /*横向表单数据模型*/
        formInline: {
          nick_name: '',
          scene: '',
          value1: ''
        },
        /*场景*/
        Scene: [],
        /*时间*/
        value1: '',
        
        /* 短信统计相关 */
        totalSmsCount: 0, // 短信总数量
        refreshing: false, // 刷新加载状态
        
        /* 调整对话框相关 */
        adjustDialogVisible: false, // 调整对话框显示状态
        adjustLoading: false, // 调整提交加载状态
        
        /* 调整表单 */
        adjustForm: {
          adjustType: 'increase', // increase: 增加, decrease: 减少, set: 直接设置
          adjustAmount: 100, // 调整数量
          setAmount: 0, // 设置数量
          reason: '', // 调整原因
          remark: '', // 操作备注
          finalAmount: 0 // 调整后数量
        },
        
        /* 调整表单验证规则 */
        adjustRules: {
          adjustAmount: [
            { validator: validateAdjustAmount, trigger: 'blur' }
          ],
          setAmount: [
            { validator: validateSetAmount, trigger: 'blur' }
          ],
          // reason: [
          //   { validator: validateReason, trigger: 'blur' }
          // ]
        }
      };
    },
    created() {
      /*获取列表*/
      this.getTableList();
      /*获取短信总数*/
      this.getTotalSmsCount();
    },
    watch: {
      // 监听调整类型和数量变化，计算最终数量
      'adjustForm.adjustType': function() {
        this.calculateFinalAmount();
      },
      'adjustForm.adjustAmount': function() {
        this.calculateFinalAmount();
      },
      'adjustForm.setAmount': function() {
        this.calculateFinalAmount();
      },
      'totalSmsCount': function() {
        this.calculateFinalAmount();
      }
    },
    methods: {
      /*选择第几页*/
      handleCurrentChange(val) {
        let self = this;
        self.curPage = val;
        self.loading = true;
        self.getTableList();
      },

      /*每页多少条*/
      handleSizeChange(val) {
        this.curPage = 1;
        this.pageSize = val;
        this.getTableList();
      },

      /*获取列表*/
      getTableList() {
        let self = this;
        let Params = self.formInline;
        Params.page = self.curPage;
        Params.list_rows = self.pageSize;
        UserApi.BxLog({
          Params: Params
        }, true).then(data => {
          self.loading = false;
          self.tableData = data.data.list.data;
          self.totalDataNumber = data.data.list.total;
          self.Scene = data.data.attributes.scene;
          self.totalSmsCount = data.data.totalSmsCount
        }).catch(error => {
          self.loading = false;
          self.$message.error('获取列表失败');
        });
      },

      /* 获取短信总数 */
      getTotalSmsCount() {
        let self = this;
        // 这里需要调用API获取短信总数
        // 假设有一个名为 getSmsTotal 的API
        UserApi.getSmsTotal({}, true).then(data => {
          self.totalSmsCount = data.data.total || 0;
        }).catch(error => {
          self.$message.error('获取短信总数失败');
        });
      },
      
      /* 刷新短信数量 */
      refreshSmsCount() {
        this.refreshing = true;
        this.getTotalSmsCount();
        setTimeout(() => {
          this.refreshing = false;
          this.$message.success('刷新成功');
        }, 500);
      },
      
      /* 显示调整对话框 */
      showAdjustDialog() {
        this.adjustDialogVisible = true;
        // 重置表单
        if (this.$refs.adjustForm) {
          this.$refs.adjustForm.resetFields();
        }
        this.adjustForm.adjustType = 'increase';
        this.adjustForm.adjustAmount = 100;
        this.adjustForm.setAmount = this.totalSmsCount;
        this.adjustForm.reason = '';
        this.adjustForm.remark = '';
        this.calculateFinalAmount();
      },
      
      /* 计算最终数量 */
      calculateFinalAmount() {
        const { adjustType, adjustAmount, setAmount } = this.adjustForm;
        
        switch (adjustType) {
          case 'increase':
            this.adjustForm.finalAmount = this.totalSmsCount + (adjustAmount || 0);
            break;
          case 'decrease':
            this.adjustForm.finalAmount = this.totalSmsCount - (adjustAmount || 0);
            // 不能为负数
            if (this.adjustForm.finalAmount < 0) {
              this.adjustForm.finalAmount = 0;
            }
            break;
          case 'set':
            this.adjustForm.finalAmount = setAmount || 0;
            break;
          default:
            this.adjustForm.finalAmount = this.totalSmsCount;
        }
      },
      
      /* 提交调整 */
      submitAdjust() {
        this.$refs.adjustForm.validate((valid) => {
          if (valid) {
            this.adjustLoading = true;
            
            // 构建提交数据
            const submitData = {
              adjust_type: this.adjustForm.adjustType,
              adjust_amount: this.adjustForm.adjustAmount,
              set_amount: this.adjustForm.setAmount,
              final_amount: this.adjustForm.finalAmount,
              reason: this.adjustForm.reason,
              remark: this.adjustForm.remark,
              current_total: this.totalSmsCount
            };
            
            // 调用API调整短信数量
            // 假设有一个名为 adjustSmsTotal 的API
            UserApi.adjustSmsTotal(submitData, true).then(data => {
              this.adjustLoading = false;
              this.adjustDialogVisible = false;
              
              // 更新显示的数量
              this.totalSmsCount = this.adjustForm.finalAmount;
              
              this.$message.success('短信数量调整成功');
              
              // 刷新列表
              this.getTableList();
              
            }).catch(error => {
              this.adjustLoading = false;
              this.$message.error('调整失败：' + (error.message || '服务器错误'));
            });
          }
        });
      },

      /*搜索查询*/
      onSubmit() {
        let self = this;
        self.loading = true;
        self.getTableList();
      },

      /*关闭弹窗*/
      closeDialogFunc(e, f) {
        if (f == 'add') {
          this.open_add = e.openDialog;
          if (e.type == 'success') {
            this.getTableList();
          }
        }
        if (f == 'edit') {
          this.open_edit = e.openDialog;
          if (e.type == 'success') {
            this.getTableList();
          }
        }
      },
    }
  };
</script>

<style scoped>
.sms-statistics-card {
  margin-bottom: 20px;
}

.statistics-card {
  border: 1px solid #e4e7ed;
}

.statistics-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 0;
}

.statistics-item {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.statistics-label {
  font-size: 14px;
  color: #909399;
  margin-bottom: 8px;
}

.statistics-value {
  display: flex;
  align-items: baseline;
}

.sms-count {
  font-size: 32px;
  font-weight: bold;
  color: #409EFF;
  margin-right: 4px;
}

.sms-unit {
  font-size: 16px;
  color: #606266;
}

.statistics-operations {
  display: flex;
  gap: 10px;
}

.gray9 {
  color: #999;
}
</style>


// WEBPACK FOOTER //
// src/views/user/dx/log.vue